import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  cell: {
    fontSize: 14,
    fontFamily: 'NeoSansStd',
    color: '#fff',
  },
  tableSortRoot: {
    maxWidth: '100%',
    '&.MuiTableSortLabel-active': {
      color: '#fff',
    },
  },
  visible: {
    opacity: 1,
    marginRight: 0,
    fontSize: 'unset',
  },
}));
